<app-deal
  [approvals]="approvals$ | async"
  [approvalsLoading]="approvalsLoading$ | async"
  [offerOptions]="combinedOfferOptionData$ | async"
  [deal]="deal"
  [offers]="dealOffers$ | async"
  [appQuestionsLoading]="appQuestionsLoading$ | async"
  [applications]="dealApplications$ | async"
  [bulkSubmitting]="bulkSubmitting"
  [questions]="dealApplicationQuestions$ | async"
  [dateSigned]="dateSigned$ | async"
  [hasSignedApplication]="hasSignedApplication$ | async"
  [questionRequirementsMet]="questionRequirementsMet$ | async"
  [canReactivateDeals]="canReactivateDeals$ | async"
  [readOnly]="readOnly"
  [showDealRightColumn]="showDealRightColumn"
  [hasContractRequest]="hasContractRequest$ | async"
  (appComplete)="updateToAppComplete()"
  (submit)="submit.emit($event)"
  >
</app-deal>
